import React, { useState } from 'react';
import { UserInfo } from 'core/Profile/UserInfo';
import { AboutMyself } from 'core/Profile/AboutMyself';
import ProfBackground from 'core/Profile/ProfBackground';
import PartialLoader from '../../../components/layout/PartialLoader';
import {
  PROFILE_MENU_CURRENT_USER_EXPERT_OWNER,
  PROFILE_MENU_CURRENT_USER_EXPERT_GUEST,
} from 'constants/profilePage';
import styles from '../../../components/NavbarPageContent/NavbarPageContent.module.scss';
import TabSelect from '../../../components/Tabs';
import CardsAndWallets from '../../../core/Profile/CardsAndWallets';
import { useSelectedContext } from 'context/contextSelector';

const ProfilePageContent = ({ userProps, isCurrentUser, setUserProps, selectUser }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelectedContext((context) => context.user);
  const [activeTab, setActiveTab] = useState(0);
  const [activeChildTab, setActiveChildTab] = useState(0);

  return (
    <>
      <UserInfo
        userProps={userProps}
        isCurrentUser={isCurrentUser}
        setUserProps={setUserProps}
        changeIsLoading={setIsLoading}
        selectUser={selectUser}
      />
      <div className={styles.tabsContainer}>
        <TabSelect
          userProps={userProps}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setActiveChildTab={setActiveChildTab}
          activeChildTab={activeChildTab}
          options={
            userProps.id === user.id
              ? PROFILE_MENU_CURRENT_USER_EXPERT_OWNER
              : PROFILE_MENU_CURRENT_USER_EXPERT_GUEST
          }
        />
      </div>
      {activeTab === 0 && selectUser && (
        <AboutMyself
          userProps={userProps}
          setUserProps={setUserProps}
          isCurrentUser={isCurrentUser}
          changeIsLoading={setIsLoading}
          selectUser={selectUser}
        />
      )}
      {activeTab === 1 && (
        <ProfBackground
          userProps={userProps}
          isCurrentUser={isCurrentUser}
          setUserData={setUserProps}
        />
      )}
      {activeTab === 2 && <CardsAndWallets activeChildTab={activeChildTab} />}
      <PartialLoader loading={isLoading} isLightContainer />
    </>
  );
};

export default ProfilePageContent;
